import { useLocation, useParams } from 'react-router-dom'
import Header from 'components/headers/addLoan'
import HandIcon from 'assets/images/easyPay/init.svg'
import DotsLoading from 'components/loadings/dotsLoading'
import style from '../payForOther/payForOther.module.scss'
import classNames from 'classnames'
import { useState } from 'react'
import { toast } from 'react-toastify'
import AddJustPayForOtherModal from 'components/modals/addJustPayForOthers'
import useSetInitPayment from './hooks/useSetInitPayment'
import useSetPay from './hooks/useSetPay'
import {
    getActiveGateways,
    useActiveGatewayCode,
} from 'utilities/hooks/useIsDefaultGateway'

export default function PayForOtherInLoan() {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const { state } = useLocation()
    const { data, isLoading } = useSetInitPayment(
        Number(state?.item?.id),
        Number(state?.item?.unpaid_portion),
        state?.selectedInstallment
    )
    const { moneyPool } = useParams()
    const { mutate } = useSetPay()
    const [selectedCode, setSelectedCode] = useState<string | null>(null)

    const activeGateways = getActiveGateways(data)
    useActiveGatewayCode(data, setSelectedCode)

    return (
        <>
            <div className=" h-screen relative">
                <Header title="" />
                <div className="">
                    {data && state && !isLoading ? (
                        <>
                            <div className=" relative">
                                <img
                                    src={HandIcon}
                                    alt="hand"
                                    className=" mx-auto absolute -top-16 z-50 right-32"
                                />

                                <div className={style['StyledReceipt']}>
                                    <div>
                                        <p>واریز به:</p>
                                        <p>همیان</p>
                                        <hr className=" mt-2" />
                                    </div>
                                    <div className=" flex justify-between mt-1">
                                        <p className="">مبلغ:</p>
                                        <p>
                                            {state?.item?.unpaid_portion &&
                                                state?.item?.unpaid_portion.toLocaleString()}{' '}
                                            تومان
                                        </p>
                                    </div>
                                    <div className=" flex justify-between mt-2">
                                        <p className="">هزینه اشتراک:</p>
                                        <p>
                                            {Number(
                                                data.commission
                                            ).toLocaleString()}{' '}
                                            تومان
                                        </p>
                                    </div>
                                    <div className=" flex justify-between mt-2">
                                        <p className=""> بابت:</p>
                                        <p>پرداخت وام</p>
                                    </div>
                                    <div className=" flex justify-between mt-2">
                                        <p className="">نام صندوق:</p>
                                        <p>{state?.name}</p>
                                    </div>
                                    <hr className=" my-4" />
                                    <div className=" flex justify-between mt-2">
                                        <p className="">مبلغ:</p>
                                        <p>
                                            {Number(
                                                state?.item?.unpaid_portion +
                                                    data.commission
                                            ).toLocaleString()}{' '}
                                            تومان
                                        </p>
                                    </div>
                                </div>
                                <div className=" w-full items-center text-center my-4">
                                    <div className="flex justify-center h-20 w-1/2 mr-[25%]">
                                        {activeGateways.map((gw) => (
                                            <img
                                                key={gw.unique_code}
                                                src={gw.img_url}
                                                alt={gw.unique_code}
                                                className={classNames(
                                                    'mx-2 cursor-pointer',
                                                    selectedCode === gw.unique_code
                                                        ? 'border-2 border-green-1 rounded-md'
                                                        : 'border-1 border-gray-4 rounded-md'
                                                )}
                                                onClick={() => setSelectedCode(gw.unique_code)}
                                            />
                                        ))}
                                    </div>
                                </div>
                            </div>
                            <div className=" bottom-10 absolute w-full">
                                <div className=" w-full">
                                    <div
                                        className=" mx-8 rounded-2xl  bg-green-1 text-white text-center py-3 my-2 cursor-pointer"
                                        onClick={() => {
                                            if (data) {
                                                if (selectedCode !== null) {
                                                    const payload: IGatewayPaymentPayload =
                                                            {
                                                                paymentItems: [
                                                                    {
                                                                        itemAmount: Number(data?.amount),
                                                                        itemType: "ins",
                                                                        itemId: state?.selectedInstallment,
                                                                        box_id: Number(moneyPool),
                                                                        commission: Number(data?.commission),
                                                                        description: "پرداخت قسط",
                                                                    }
                                                                ],
                                                                gateway: {
                                                                    uniqueCode: selectedCode,
                                                                },
                                                                clientType: 'pwa',
                                                            }
                                                        mutate(payload)
                                                } else {
                                                    toast.error(
                                                        'نوع درگاه پرداخت را انتخاب کنید'
                                                    )
                                                }
                                            }
                                        }}
                                    >
                                        پرداخت آنلاین
                                    </div>
                                </div>
                                {state?.isManager && (
                                    <div className=" w-full">
                                        <div
                                            className=" mx-8 rounded-2xl border-1 border-green-1  bg-white text-green-1 text-center py-3 my-2 cursor-pointer"
                                            onClick={() => {
                                                if (data) {
                                                    if (selectedCode !== null) {
                                                        setIsOpen(true)
                                                    } else {
                                                        toast.error(
                                                            'نوع درگاه پرداخت را انتخاب کنید'
                                                        )
                                                    }
                                                }
                                            }}
                                        >
                                            ثبت پرداخت
                                        </div>
                                    </div>
                                )}
                            </div>
                        </>
                    ) : (
                        <DotsLoading />
                    )}
                </div>
            </div>
            <AddJustPayForOtherModal
                show={isOpen}
                onHide={() => setIsOpen(false)}
            />
        </>
    )
}
